import {PageableResponseWrapper, PageQueryParams} from "../../../domain/response-wrapper";
import {useQueryParams} from "../../../hooks/useQueryParams";
import {useFetch} from "../../../hooks/useFetch";
import {Transaction} from "../../../domain/transaction";
import {getDateRange, getFormatToSendApi} from "../util/GetDateRangeUtil";
import {DateRangeOption} from "../enum/Dashboard.enum";

interface TransactionFiltersQueryParams extends PageQueryParams {
  idBranch?: string[];
  idMerchant?: string[];
  start?: string;
  end?: string;
}

// `size: 0` causaba un 500 en el BFF (page size inválido) — mismo bug que
// useDashboardTransactionFilters.tsx. La gráfica de dona necesita todas las
// transacciones del rango seleccionado, no una página chica.
//
// start/end arrancan con "esta semana" en vez de undefined: sin un rango por
// default, la primera llamada (antes de que el usuario toque el selector de
// fecha de la dona) salía sin acotar por fecha, pidiendo hasta 1000
// transacciones de todo el histórico.
const defaultRange = getFormatToSendApi(getDateRange(DateRangeOption.THIS_WEEK));

const initialFilters: TransactionFiltersQueryParams = {
  page: 0,
  size: 1000,
  idMerchant: [],
  idBranch: [],
  start: defaultRange.startDate,
  end: defaultRange.endDate,
}

export const useTransactionsFilterByDateApi = () => {
  const {
    updateParams,
    queryParams,
  } = useQueryParams<TransactionFiltersQueryParams>(initialFilters);

  const {
    data,
    loading,
    error,
  } = useFetch<PageableResponseWrapper<Transaction>>('/transactions-view', queryParams);

  return {
    updateParams,
    queryParams,
    results: data,
    error,
    loading,
  }
}
